import { FixedSizeList } from 'react-window';
import React from 'react';

const LISTBOX_PADDING = 8; // Optional

const renderRow = (props: any) => {
  const { data, index, style } = props;
  return React.cloneElement(data[index], {
    style: {
      ...style,
      top: (style.top as number) + LISTBOX_PADDING
    }
  });
};

export const ListboxComponent = React.forwardRef(function ListboxComponent(
  props: React.HTMLAttributes<HTMLElement>,
  ref: React.Ref<HTMLDivElement>
) {
  const { children, ...other } = props;
  const itemData = React.Children.toArray(children);
  const itemCount = itemData.length;
  const itemSize = 46;

  const height = Math.min(8, itemCount) * itemSize + 2 * LISTBOX_PADDING;

  return (
    <div ref={ref} {...other}>
      <FixedSizeList height={height} width="100%" itemSize={itemSize} itemCount={itemCount} itemData={itemData} overscanCount={5}>
        {renderRow}
      </FixedSizeList>
    </div>
  );
});
